<template>
  <div>
    <div class="jz-detail-head-211130">
      <h3 class="title">款项结转</h3>
      <div class="tip">
        详情编号: {{ row.paymentsNum }} | 申请人:
        {{ row.createUser }} | 申请日期:
        {{ row.createTime | timeFormatDate }}
      </div>
    </div>
    <div class="clearfix">
      <div class="add-box clearfix">
        <vxe-table
          border
          show-overflow
          keep-source
          class="table-style"
          :auto-resize="true"
          :data="tableData"
        >
          <vxe-table-column
            type="seq"
            width="60"
            align="center"
            title="序号"
          ></vxe-table-column>
          <vxe-table-column
            width="130"
            field="addTime"
            title="日期"
            align="center"
          >
            <template slot-scope="{ row }">
              <span>{{ row.addTime | timeFormatDate }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column
            width="200"
            field="compName"
            title="所属公司"
            align="center"
          >
          </vxe-table-column>
          <vxe-table-column
            width="140"
            field="note"
            title="摘要"
            align="center"
          >
          </vxe-table-column>
          <vxe-table-column
            width="140"
            field="paymentType"
            title="一级科目"
            align="center"
          >
          </vxe-table-column>
          <vxe-table-column
            width="140"
            field="secondSubject"
            title="二级科目"
            align="center"
          >
          </vxe-table-column>
          <vxe-table-column
            width="140"
            field="thirdSubject"
            title="三级科目"
            align="center"
          >
          </vxe-table-column>
          <vxe-table-column
            field="ordersNum"
            width="150"
            title="关联订单"
            align="center"
          >
          </vxe-table-column>
          <vxe-table-column
            width="140"
            field="debiteAmount"
            title="借方金额"
            align="center"
          >
          </vxe-table-column>
          <vxe-table-column
            width="140"
            field="creditAmount"
            title="贷方金额"
            align="center"
          >
          </vxe-table-column>
          <vxe-table-column
            width="140"
            field="recName"
            title="银行账户"
            align="center"
          >
          </vxe-table-column>
        </vxe-table>
        <div>
          <vxe-table
            border
            show-overflow
            keep-source
            :data="tableData"
            class="table_insert"
            max-height="140"
            :auto-resize="true"
            :edit-config="{ trigger: 'click', mode: 'cell', showIcon: false }"
          >
            <vxe-table-column field="fileList" title="查看附件">
              <template v-slot="{ row }">
                <upload-list
                  :isEdit="false"
                  :row="row"
                  :initFileList="row.fileList"
                  :view="'arrange'"
                  ref="uploadList"
                ></upload-list>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
      </div>
      <!-- 弹窗 -->
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import UploadList from "@/components/common/UploadList";
export default {
  components: {
    UploadList,
  },
  props: {
    isShow: Boolean,
  },
  data() {
    return {
      row: {
        paymentsNum: null,
        createUser: null,
        createTime: null
      },
      tableData: [],
      subjectType: [],
    };
  },
  methods: {
    async initDetail(id) {
      $api.subject.queryCarryOverSubject1.GET().then((res) => {
        if (res.status === 1) {
          this.subjectType = res.data.map((item) => {
            return {
              label: item.paramValue,
              value: parseInt(item.paramId),
            };
          });
        }
      });
      let params = {
        page: 1,
        rows: 10000,
        orderBy: 2,
        isDesc: 0,
        id,
      };
      let resData = await $api.paymentsTwo.request("queryCarryOverList", params);
      if (resData.status == 1) {
        this.tableData = resData.data.rows.map((item) => {
          return Object.assign(item, {
            paymentType: this.carryOverPaymentType(item.paymentType),
            fileList: item.fileUuidList,
          });
        });
        this.row.paymentsNum = this.tableData[0].paymentsNum
        this.row.createUser = this.tableData[0].createUser
        this.row.createTime = this.tableData[0].createTime
      }
      console.log(id);
    },
    carryOverPaymentType(id) {
      let arr = this.subjectType.filter((item) => item.value == id);
      if (arr && arr.length === 1) {
        return arr[0].label;
      } else {
        return null;
      }
    },
  },
};
</script>

<style>
</style>